export const INCLUDE_OPERATORS = ['includeAny', 'includeAll'];
export const EXCLUDE_OPERATORS = ['excludeAny', 'excludeAll'];
export const LINK_OPERATORS = [...INCLUDE_OPERATORS, ...EXCLUDE_OPERATORS];

export const campaignLinkKey = link => JSON.stringify([
    link.campaignId, link.requirement, link.operator, [...new Set(link.values)].sort()
]);

// Order from the API is not significant. Preserve the entire condition, including other tests.
export const normalizeCampaignLinks = (links = []) => [...new Map((links || []).map(link => {
    const normalized = {...link, values: [...new Set(link.values)].sort()};
    return [campaignLinkKey(normalized), normalized];
})).values()].sort((a, b) => a.campaignId.localeCompare(b.campaignId)
    || campaignLinkKey(a).localeCompare(campaignLinkKey(b)));

export const indexCampaignLinks = (testId, links) => {
    const index = {
        testIncludes: [],
        testExcludes: [],
        cohortIncludes: new Map(),
        cohortExcludes: new Map(),
    };
    normalizeCampaignLinks(links).forEach(link => {
        const include = INCLUDE_OPERATORS.includes(link.operator);
        if (!include && !EXCLUDE_OPERATORS.includes(link.operator)) return;
        if (link.requirement === 'ab_test') {
            if (link.values.includes(testId)) index[include ? 'testIncludes' : 'testExcludes'].push(link);
        } else if (link.requirement === 'ab_test_cohort') {
            const groups = include ? index.cohortIncludes : index.cohortExcludes;
            const prefix = `${testId}:`;
            link.values.filter(value => value.startsWith(prefix)).forEach(value => {
                const cohortId = value.slice(prefix.length);
                if (!cohortId) return;
                if (!groups.has(cohortId)) groups.set(cohortId, []);
                groups.get(cohortId).push(link);
            });
        }
    });
    return index;
};

export const getCohortIncludes = (index, cohortId) =>
    normalizeCampaignLinks([...index.testIncludes, ...(index.cohortIncludes.get(cohortId) || [])]);
